<div class="year-selector">
  <!-- Previous Year Button -->
  <div class="action-group">
    <button class="year-arrow" *ngIf="!isDropdownOpen" (click)="prevYear()"
      [disabled]="isYearDisabled(selectedYear - 1)">
      < </button>
        <button class="year-arrow" *ngIf="isDropdownOpen" (click)="prevDecade()" [disabled]="startYear <= minYear">
          < </button>
  </div>

  <!-- Dropdown -->
  <div class="dropdown">
    <button mat-button class="dropdown-toggle" (click)="isDropdownOpen = !isDropdownOpen">
      {{ selectedYear }}
    </button>
    <div class="dropdown-menu" *ngIf="isDropdownOpen">

      <!-- Year Grid -->
      <div class="year-grid">
        <div *ngFor="let year of years" [class.selected]="year === selectedYear" [class.disabled]="isYearDisabled(year)"
          (click)="selectYear(year)">
          {{ year }}
        </div>
      </div>
    </div>
  </div>

  <!-- Next Year Button -->
  <div class="action-group">
    <button class="year-arrow" *ngIf="!isDropdownOpen" (click)="nextYear()"
      [disabled]="isYearDisabled(selectedYear + 1)">
      >
    </button>
    <button class="year-arrow" *ngIf="isDropdownOpen" (click)="nextDecade()" [disabled]="endYear >= maxYear">
      >
    </button>
  </div>
</div>